import { ChartData } from 'chart.js';
import { Chart } from 'primereact/chart';
type ChartShareProps = {
  chartData: ChartData<'pie'>;
  total: number;
  percentage?: { user: string; percentage: string }[] | number;
  totalLabel: string;
  percentageLabel?: string;
  labelColorPairs?: { label: string; color: string }[];
  isMultiPercentage?: boolean;
};
const chartOptions = { plugins: { legend: { display: false } } };
export const ChartShare: React.FC<ChartShareProps> = ({
  chartData,
  total,
  percentage,
  totalLabel,
  percentageLabel,
  labelColorPairs,
  isMultiPercentage,
}) => {
  const layoutStyle = isMultiPercentage
    ? 'grid grid-cols-3 gap-10'
    : 'flex flex-row items-center justify-between';

  const percentageMap = Array.isArray(percentage)
    ? percentage.reduce(
      (acc, { user, percentage }) => ({ ...acc, [user]: percentage }),
        {} as Record<string, string>,
    )
    : {};

  return (
    <div className={`${layoutStyle} px-20 py-10`}>
      <Chart type="pie" data={chartData} options={chartOptions} />
      <div>
        <span className="text-lg">
          {totalLabel}: {total}
        </span>
        <ul className="pl-5 list-disc">
          {labelColorPairs?.map(({ label, color }) => (
            <li className="flex flex-row items-center gap-2 my-1" key={label}>
              <div className="w-3 h-3" style={{ backgroundColor: color }} />
              <span className="text-sm">
                {label}
                {isMultiPercentage && (
                  <strong>({percentageMap[label]}%)</strong>
                )}
              </span>
            </li>
          ))}
        </ul>
      </div>
      {percentage !== undefined && !isMultiPercentage && (
        <div className="flex flex-col items-center text-2xl font-semibold">
          <span>{typeof percentage === 'number' ? percentage : 0}%</span>
          <span>{percentageLabel}</span>
        </div>
      )}
    </div>
  );
};
